import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const StoreUserCount = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 flex flex-col gap-3 rounded-md p-5 duration-150'>

      <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
        {store} 고객 현황
      </div>

      <div className='flex justify-between items-center'>
        <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p>
        <p>|</p>
        <p className='tracking-wider'>{`${NumberConvert(Number(data.data0))} 명`}</p>
      </div>

    </div>
  )
}

export default StoreUserCount